import { ref } from 'vue'
import { MensajesApi } from '@/services/MensajeServices'

const unreadCount = ref(0)
const isLoading = ref(false)
let intervalId: ReturnType<typeof setInterval> | null = null

export function useUnreadMessages() {
  const fetchUnreadCount = async () => {
    if (isLoading.value) return
    
    try {
      isLoading.value = true
      const response = await MensajesApi.getUnreadCount()
      unreadCount.value = response.count
    } catch (error) {
      // Error silencioso para evitar spam en consola
    } finally {
      isLoading.value = false
    }
  }

  const startPolling = (intervalMs = 30000) => { // 30 segundos por defecto
    // Obtener contador inicial
    fetchUnreadCount()
    
    // Limpiar intervalo existente si existe
    if (intervalId) {
      clearInterval(intervalId)
    }
    
    // Configurar nuevo intervalo
    intervalId = setInterval(fetchUnreadCount, intervalMs)
  }

  const stopPolling = () => {
    if (intervalId) {
      clearInterval(intervalId)
      intervalId = null
    }
  }

  const decrementCount = () => {
    if (unreadCount.value > 0) {
      unreadCount.value--
    }
  }

  const incrementCount = () => {
    unreadCount.value++
  }

  const resetCount = () => {
    unreadCount.value = 0
  }

  return {
    unreadCount,
    isLoading,
    fetchUnreadCount,
    startPolling,
    stopPolling,
    decrementCount,
    incrementCount,
    resetCount
  }
}